import React, { useState } from 'react';
import { useAuthActions } from '@convex-dev/auth/react';

export function Login() {
  const { signIn } = useAuthActions();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password) {
      setError('REQUISITO: Rellenar todos los campos del terminal.');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      await signIn('password', { email, password, flow: 'signIn' });
    } catch (err: any) {
      console.error(err);
      const errMsg = err.message || String(err);

      // Traducciones amigables para el operador
      if (errMsg.includes('InvalidAccountId') || errMsg.includes('InvalidPassword')) {
        setError('ACCESO DENEGADO: Credenciales incorrectas.');
      } else {
        setError('ACCESO DENEGADO: ' + errMsg);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-dvh flex items-center justify-center p-6 select-none relative">
      <div className="w-full max-w-md term-box reveal-up">
        {/* Terminal Header */}
        <div className="term-header px-4 py-2.5 flex items-center justify-between">
          <span className="font-mono text-xs uppercase tracking-wider font-semibold">
            sys_transcribe // gateway.sh
          </span>
          <div className="flex gap-1.5">
            <span className="w-2.5 h-2.5 rounded-full bg-[var(--color-asphalt-500)] opacity-40"></span>
            <span className="w-2.5 h-2.5 rounded-full bg-[var(--color-amber-mid)] opacity-40"></span>
            <span className="w-2.5 h-2.5 rounded-full bg-[var(--color-asphalt)] shadow-[var(--glow-green)]"></span>
          </div>
        </div>

        {/* Terminal Body */}
        <div className="p-6 sm:p-8 space-y-6">
          <div className="space-y-2">
            <div className="font-mono text-[10px] text-[var(--color-asphalt-500)] uppercase tracking-[0.2em]">
              [+] ESTABLECIENDO CANAL SEGURO
            </div>
            <h2 className="heading-display text-4xl sm:text-5xl tracking-tight">
              DECRYPT_<em>SESSION</em>
            </h2>
            <p className="font-mono text-xs text-[var(--color-asphalt-500)]">
              // Ingrese credenciales autorizadas para desbloquear el sistema
              <span className="term-caret" aria-hidden />
            </p>
          </div>

          <form onSubmit={handleLogin} className="space-y-4 font-mono">
            {/* Email Field */}
            <div className="space-y-1.5">
              <label htmlFor="email-input" className="label-mono block text-xs">
                email_address
              </label>
              <div className="relative">
                <span className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[var(--color-asphalt-500)] text-xs">
                  $
                </span>
                <input
                  id="email-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="admin@dromos.co"
                  disabled={loading}
                  className="term-input pl-8 py-2.5 text-xs"
                  autoComplete="username"
                  required
                />
              </div>
            </div>

            {/* Password Field */}
            <div className="space-y-1.5">
              <label htmlFor="password-input" className="label-mono block text-xs">
                access_password
              </label>
              <div className="relative">
                <span className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[var(--color-asphalt-500)] text-xs">
                  *
                </span>
                <input
                  id="password-input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••••••"
                  disabled={loading}
                  className="term-input pl-8 py-2.5 text-xs"
                  autoComplete="current-password"
                  required
                />
              </div>
            </div>

            {/* Output Messages */}
            {error && (
              <div className="p-3 border border-[var(--color-burgundy)] bg-[rgba(255,46,77,0.05)] text-[var(--color-burgundy)] text-xs font-mono space-y-1 select-text">
                <div className="font-bold font-display uppercase tracking-wider text-shadow-sm">
                  [!] ERROR: ACCESS_DENIED
                </div>
                <div className="leading-relaxed">{error}</div>
              </div>
            )}

            {success && (
              <div className="p-3 border border-[var(--color-asphalt-500)] bg-[rgba(0,255,102,0.05)] text-[var(--color-asphalt)] text-xs font-mono space-y-1 select-text">
                <div className="font-bold font-display uppercase tracking-wider text-shadow-sm text-[var(--color-amber-mid)]">
                  [+] PROCESO COMPLETADO
                </div>
                <div className="leading-relaxed text-[var(--color-asphalt-700)]">{success}</div>
              </div>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className="w-full term-btn term-btn-primary justify-center py-3 text-xs tracking-[0.16em] uppercase rounded-none mt-2 font-semibold"
            >
              {loading ? 'DESENCRIPTANDO...' : 'EXEC_LOGIN --authenticate'}
            </button>
          </form>


        </div>
      </div>
    </div>
  );
}
